import React, { createContext, useEffect, useState } from "react";
import { IntlProvider } from "react-intl";

export interface ContextProps {
  language: { localeKey: string; providerKey: string };
  changeLanguage: (localeKey: string, providerKey: string) => unknown;
}

export const LanguageContext = createContext({
  language: { localeKey: "en", providerKey: "en" },
} as ContextProps);
import { useLanguages } from "~/queries";

export const LanguageContextProvider: React.FC = (props) => {
  const { children } = props;
  const [language, setLanguage] = useState({
    localeKey: "en",
    providerKey: "en",
  });
  const { data: messages } = useLanguages(language.localeKey);

  useEffect(() => {
    const selectedLanguage = localStorage.getItem("selectedLanguage");
    if (selectedLanguage) {
      setLanguage(JSON.parse(selectedLanguage));
    }
  }, []);

  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage: (localeKey: string, providerKey: string) => {
          setLanguage({ localeKey, providerKey });
          localStorage.setItem(
            "selectedLanguage",
            JSON.stringify({ localeKey, providerKey })
          );
        },
      }}
    >
      <IntlProvider
        defaultLocale="en"
        locale={language.providerKey}
        messages={messages}
      >
        {messages ? children : null}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};
